import { Task } from '../types';

export const TaskSidebarAnalytics = {
  sendHeapEvent: (eventName: string, task: Task, personId?: string) => {
    if (window.heap) {
      window.heap.track(eventName, {
        personId,
        jobId: task.job.id,
        jobType: task.job.type,
        taskId: task.id,
        taskType: task.type,
        parameters: task.job.parameters,
        dateClicked: new Date().toISOString(),
      });
    }
  },
};
